import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { allSpecies } from '../data/speciesData';
import { track } from '../services/analytics';
import TopNav from '../components/layout/TopNav';
import SpeciesHero from '../components/species/SpeciesHero';
import SpeciesContent from '../components/species/SpeciesContent';

import SpeciesAnalysis from '../components/species/SpeciesAnalysis';
import SpeciesAffiliates from '../components/species/SpeciesAffiliates';
import HomeFooter from '../components/home/HomeFooter';

const SpeciesDetailPage = () => {
  const { id } = useParams();
  const species = allSpecies.find(s => s.id === id);

  useEffect(() => {
    if (species) {
      track('page_view', { page: 'species_detail', species: species.name, category: species.category });
    }
    window.scrollTo(0, 0);
  }, [species]);

  if (!species) {
    return (
      <div className="bg-surface text-on-surface font-body min-h-screen flex items-center justify-center">
        <TopNav />
        <div className="text-center">
          <span className="material-symbols-outlined text-6xl text-primary/40 mb-4 block">search_off</span>
          <h1 className="font-headline text-3xl mb-4">Species Not Found</h1>
          <p className="text-slate-400 mb-8 font-body">The species you're looking for doesn't exist in our journal.</p>
          <Link
            to="/explorer"
            className="bg-gradient-to-r from-primary to-primary-container text-on-primary px-6 py-3 rounded-md font-label font-semibold inline-flex items-center gap-2"
          >
            <span className="material-symbols-outlined text-sm">arrow_back</span>
            Back to Explorer
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-surface text-on-surface font-body min-h-screen">
      <TopNav />
      <main className="pt-16">
        <SpeciesHero species={species} />
        <SpeciesAnalysis species={species} />
        <SpeciesContent species={species} />
        <SpeciesAffiliates species={species} />
      </main>
      <HomeFooter />
    </div>
  );
};

export default SpeciesDetailPage;
